// extracted by mini-css-extract-plugin
export default {"container":"wk-z","disabled":"xk-z","subtotal":"yk-z","legal":"zk-z"};